import { DatePicker, Form, Input, Select } from "antd";
import moment from 'moment';
import React from 'react';
import { LocationSelect } from '../../form/select/LocationSelect';
import { OrganizationSelect } from '../../form/select/OrganizationSelect';
import { getFieldKey } from '../fieldTypes';

const { RangePicker } = DatePicker;

const DATERANGE = getFieldKey('dateRange')
const CUSTOMERS = getFieldKey('customers');
const TRANSPORTERS = getFieldKey('transporters');
const NAME = getFieldKey('name');
const EMPLOYERS = getFieldKey('employers');
const DEPARTURES = getFieldKey('departures');
const DESTINATIONs = getFieldKey('destinations');
const STATUS = getFieldKey('status');

export const formatFields = (fields) => {
    var [ startDay, endDay ] = fields.dateRange;
    startDay = moment(startDay).startOf('day');
    endDay = moment(endDay).endOf('day');
    return {
        ...fields,
        dateRange: [startDay, endDay]
    }
}

const CovidVaccineForm = (form, fieldProps={}, currentCustomer, currentTransporter) => {

    const { getFieldDecorator } = form;

    return [
        <Form.Item key={DATERANGE} label="Date Range" {...fieldProps} >
            {getFieldDecorator(DATERANGE, {
                rules: [
                    {required: true, message: 'You must specify a date range'}
                ]
            })(<RangePicker format="YYYY-MM-DD" />)}
        </Form.Item>,
        <Form.Item key={TRANSPORTERS} label="Transporter" {...fieldProps} >
            {getFieldDecorator(TRANSPORTERS, {
                initialValue: currentTransporter ? currentTransporter._id : null,
                rules: [
                    {required: true, message: 'Transporter is required'}
                ]
            })(currentCustomer ? (
            <OrganizationSelect
                classTypes={['flytsuite.transporter']}
                labelInValue={false}
            />) : (
                <Select showAction={["focus", "click"]}>
                    <Select.Option value={currentTransporter._id}>{currentTransporter.name}</Select.Option>
                </Select>
            ))}
        </Form.Item>,
        <Form.Item key={CUSTOMERS} label="Customer" {...fieldProps} >
            {getFieldDecorator(CUSTOMERS, {
                initialValue: currentCustomer ? currentCustomer._id : [],
                rules: [
                    {required: currentCustomer ? true : false, message: 'Customer is required'}
                ]
            })(currentCustomer ? (
                <Select showAction={["focus", "click"]}>
                    <Select.Option value={currentCustomer._id}>{currentCustomer.name}</Select.Option>
                </Select>
            ) : (
            <OrganizationSelect
                classTypes={['flytsuite.customer']}
                mode="multiple"
                labelInValue={false}
            />)
            )}
        </Form.Item>,
        <Form.Item key={NAME} label="Passenger Name" {...fieldProps} >
        {getFieldDecorator(NAME)(<Input />)}
        </Form.Item>,
        <Form.Item key={EMPLOYERS} label="Employer" {...fieldProps}>
            {getFieldDecorator(EMPLOYERS, {
                initialValue: []
            })(<OrganizationSelect
                classTypes={['flytsuite.employer']}
                mode="multiple"
                labelInValue={false}
            />)}
        </Form.Item>,
        <Form.Item key={DEPARTURES} label="Departures" {...fieldProps}>
            {getFieldDecorator(DEPARTURES, {
                initialValue: []
            })(
                <LocationSelect
                    deleted={true}
                    mode="multiple"
                    labelInValue={false}
                />
            )}
        </Form.Item>,
        <Form.Item key={DESTINATIONs} label="Destinations" {...fieldProps}>
        {getFieldDecorator(DESTINATIONs, {
            initialValue: []
        })(
            <LocationSelect
                deleted={true}
                mode="multiple"
                labelInValue={false}
            />
        )}
        </Form.Item>,
        <Form.Item key={STATUS} label="Status" {...fieldProps}>
        {getFieldDecorator(STATUS, {
            initialValue: 'default'
        })(
            <Select showAction={["focus", "click"]}>
                <Select.Option value="default">Any</Select.Option>
                <Select.Option value="finalized">Finalized</Select.Option>
                <Select.Option value="notfinalized">Not Finalized</Select.Option>
            </Select>
        )}
        </Form.Item>
    ]
}

export default CovidVaccineForm